// extracted by mini-css-extract-plugin
export default {"imageWrapper":"zN-z","twoColumnImage":"AN-z"};